import { motion } from "framer-motion";

export const JOBS = [
  {
    startDate: "Sep. 2025",
    finishDate: "Present",
    title: "Network Monitoring Analyst",
    place: "Tecnored Latam",
    type: "Full-time",
    location: "Remote",
    description:
      "Monitoring large-scale network infrastructure, ensuring stability, fast incident detection, and high availability.",
    bullets: [
      "Monitored critical network infrastructure in real time",
      "Detected and responded to incidents with minimal downtime",
      "Improved visibility of network performance and stability",
    ],
    current: true,
  },
  {
    startDate: "Oct. 2024",
    finishDate: "Present",
    title: "Freelance Developer",
    place: "Fiverr",
    type: "Freelance",
    location: "Remote",
    description:
      "Developing desktop and web applications, automating workflows, and integrating hardware systems.",
    bullets: [
      "Built cross-platform desktop apps using Electron",
      "Automated real-time workflows for business processes",
      "Integrated peripherals and external systems",
    ],
    current: true,
  },
  {
    startDate: "Jan. 2023",
    finishDate: "Sep. 2025",
    title: "General IT Technician",
    place: "Unit 11 — Piñero",
    type: "Full-time",
    location: "On-site",
    description:
      "Installation, maintenance, and support of critical infrastructure including CCTV and IP telephony systems.",
    bullets: [
      "Installed and maintained surveillance systems (CCTV)",
      "Performed audits on internal systems",
      "Ensured reliability of on-site infrastructure",
    ],
    current: false,
  },
];

export default function Experience() {
  return (
    <section
      id="experience"
      className="border-t border-white/[0.06] bg-[#010710] px-6 py-24 text-white sm:py-32"
    >
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="grid gap-8 lg:grid-cols-[0.7fr_1.3fr]"
        >
          <h2 className="mt-4 text-4xl font-medium tracking-[-0.04em] sm:text-5xl">
            Where I've worked
          </h2>

          <p className="max-w-2xl text-base leading-8 text-white/40 lg:pt-2">
            A mix of infrastructure, software development, and freelance work.
            My experience sits at the intersection of building software and
            keeping the systems behind it reliable.
          </p>
        </motion.div>

        <div className="mt-20">
          {JOBS.map((job, index) => (
            <motion.article
              key={`${job.place}-${job.title}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                delay: index * 0.1,
                duration: 0.6,
              }}
              className="group border-t border-white/[0.07] py-10 last:border-b sm:py-12"
            >
              <div className="grid gap-8 lg:grid-cols-[180px_1fr]">
                <div className="flex items-start justify-between lg:block">
                  <div className="text-sm text-white/35">
                    {job.startDate}
                    <span className="mx-2 text-white/15 lg:hidden">—</span>
                    <span className="lg:block">{job.finishDate}</span>
                  </div>
                </div>

                <div>
                  <div className="flex flex-col gap-2 sm:flex-row sm:items-baseline sm:justify-between">
                    <div>
                      <h3 className="text-xl font-medium tracking-tight text-white transition-colors group-hover:text-white/80 sm:text-2xl">
                        {job.title}
                      </h3>

                      <p className="mt-1 text-sm text-white/35">{job.place}</p>
                    </div>

                    <div className="flex items-center gap-2 text-xs text-white/25">
                      <span>{job.type}</span>
                      <span className="h-1 w-1 rounded-full bg-white/15" />
                      <span>{job.location}</span>
                    </div>
                  </div>

                  <p className="mt-6 max-w-2xl text-sm leading-7 text-white/45">
                    {job.description}
                  </p>

                  <ul className="mt-6 grid gap-2">
                    {job.bullets.map((bullet, bulletIndex) => (
                      <li
                        key={bulletIndex}
                        className="flex gap-3 text-sm leading-6 text-white/35"
                      >
                        <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-white/20" />
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
